module.exports = __webpack_public_path__ + "static/headshot--full-size-d350d864731df8996b9b782ad9201496.png";